import React, { useMemo } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from "recharts";
import { ViolationTrendPoint } from "../types";
import "./ViolationTrendChart.css";

interface ViolationTrendChartProps {
  data: ViolationTrendPoint[] | null;
  loading?: boolean;
}

const CustomTooltip = ({ active, payload, label }: any) => {
  if (!active || !payload?.length) return null;
  const count = payload[0].value as number;
  return (
    <div className="trend-tooltip">
      <div className="trend-tooltip-day">{label}</div>
      <div className="trend-tooltip-count">
        {count} {count === 1 ? "violation" : "violations"}
      </div>
    </div>
  );
};

const ViolationTrendChart: React.FC<ViolationTrendChartProps> = ({ data, loading }) => {
  const maxCount = useMemo(() => {
    if (!data) return 0;
    return data.reduce((m, p) => Math.max(m, p.count), 0);
  }, [data]);

  if (loading || !data) {
    return (
      <div className="trend-chart">
        <div className="trend-chart-skeleton" aria-hidden="true" />
      </div>
    );
  }

  return (
    <div className="trend-chart">
      <ResponsiveContainer width="100%" height={90}>
        <BarChart data={data} margin={{ top: 4, right: 4, left: 0, bottom: 0 }}>
          <XAxis
            dataKey="dayOfWeek"
            tickLine={false}
            axisLine={false}
            tick={{ fontSize: 10, fill: "var(--text-medium)" }}
            interval={0}
          />
          <YAxis hide domain={[0, (dataMax: number) => Math.max(dataMax, 1)]} />
          <Tooltip content={<CustomTooltip />} cursor={{ fill: "var(--faded-blue)" }} />
          <Bar dataKey="count" radius={[4, 4, 0, 0]} minPointSize={maxCount > 0 ? 2 : 0}>
            {data.map((entry, idx) => (
              <Cell
                key={idx}
                fill={maxCount > 0 && entry.count === maxCount ? "var(--parallel-blue)" : "var(--faded-blue)"}
              />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ViolationTrendChart;
